// extracted by mini-css-extract-plugin
export default {"caption":"CoverInfo_caption__MLxjV"};